var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPython(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 225,
    height: 225,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfdfc",
      stroke: "none"
    },
    d: "M0 0L0 100L1 100C1.30706 85.123 8.54811 67.3013 23 60.966C32.8943 56.6288 44.4883 58 55 58L113 58L113 51L58 51C58 41.4436 55.9415 29.1047 59.1088 20C64.1661 5.46211 84.4468 1.0374 98 1L68 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M98 0L98 1L101 1L98 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3974a5",
      stroke: "none"
    },
    d: "M78 6L75 5L76 7L75 7L68 11C52.3549 13.2965 60.3127 39.172 58 49C69.1468 53.6113 86.0593 50 98 50C105.385 50 112.697 48.745 113 58L27 59L28 61L27 61C19.1936 60.1013 8.01134 70.1623 8 78L6 78L7 80C-1.56621 86.4384 -0.568521 109.391 0.0895062 119C0.34389 122.715 0.143052 128.504 3 131L3 140L5 140L4 144L8 148L7 151L10 152L11 154L14 157C14.5962 158.884 16.1497 163.689 18 161L20 165L23 164L22 166L51 168L51 131L53 131L52 128L53 125L54 123L56 120L62 113L65 114L66 111L76 110L94 109L141 109L141 108L139 108L139 107L146 108C146 104.454 149.312 105.293 152 106L153 102L156 104L160 97L163 97L162 95L164 95L163 92L165 93L165 86L166 86L166 88L167 88C165.3 71.8194 165.962 55.3162 166 39C166.01 34.5527 169.731 24.2281 164 23L166 20L165 18L162 17C161.343 13.2881 159.752 12.1588 156 12L156 9L154 8L152 9L152 7L150 8L150 6L138 4L138 2C123.888 2.90816 109.441 0.184219 95 1.17593C89.8375 1.53046 81.3214 1.63232 78 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M123 0L123 1L126 1L123 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfdfc",
      stroke: "none"
    },
    d: "M126 0L126 1C141.226 1.12605 160.829 7.27432 166.451 23C170.553 34.4733 168 49.9431 168 62C168 77.2069 169.464 94.2009 154.999 103.696C128.491 121.097 87.4892 95.739 62.0401 115.61C47.1738 127.217 51 151.5 51 168C43.3823 168 34.3763 169.307 27 167.211C9.41301 162.214 1.13945 141.846 1 125L0 125L0 225L103 225L103 224C86.8259 223.989 64.3916 218.593 58.9051 201C55.5988 190.398 58 176.057 58 165C58 153.551 55.8988 139.394 62.5293 129.285C70.8167 116.651 83.4248 116 97 116C115.467 116 137.199 119.119 154.996 113.491C172.468 107.965 174 91.5965 174 76C174 71.5835 172.214 61.9925 175.603 58.6034C178.502 55.705 185.265 57.0489 188.985 56.9753C209.105 56.5775 223.531 72.9445 224 93L225 93L225 0L126 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M89.6667 1.33333L90.3333 1.66667L89.6667 1.33333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M94.6667 1.33333L95.3333 1.66667L94.6667 1.33333M128 1L129 2L128 1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M132.667 1.33333L133.333 1.66667L132.667 1.33333M84.6667 2.33333L85.3333 2.66667L84.6667 2.33333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M133 2L133 3L136 3L133 2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M138 2L139 3L138 2M80 3L81 4L80 3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M138.667 3.33333L139.333 3.66667L138.667 3.33333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M142 3L143 4L142 3M77 4L78 5L77 4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M136 4L137 5L136 4M143 4L144 5L143 4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M145 4L146 5L145 4M74 5L75 6L74 5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M77 5L78 6L77 5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M148 5L149 6L148 5M72 6L73 7L72 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M74.6667 6.33333L75.3333 6.66667L74.6667 6.33333M148 6L149 7L148 6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M150 6L151 7L150 6M70 7L71 8L70 7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M150 7L151 8L150 7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M152 7L153 8L152 7M68 8L69 9L68 8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M152 8L153 9L152 8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M154 8L155 9L154 8M67 9L68 10L67 9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M69 9L70 10L69 9M154 9L155 10L154 9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M158 9L159 10L158 9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M67 10L68 11L67 10M155 10L158 12L155 10z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M157 10L158 11L157 10M64 11L63 13L64 11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M64 12L65 13L64 12M158 12L162 16L158 12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M62 13L63 14L62 13M61 14L62 15L61 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M63 14L62 16L63 14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M60 16L61 17L60 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M81.6667 16.3333L82.3333 16.6667L81.6667 16.3333M162 16L163 17L162 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M163 16L164 17L163 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M77 17L78 18L77 17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M79.6667 17.3333L80.3333 17.6667L79.6667 17.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfdfc",
      stroke: "none"
    },
    d: "M81 17.7184C68.5786 19.1691 70.9551 38.1719 83 36.7276C95.1454 35.2713 93.0624 16.3096 81 17.7184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M83 17L84 18L83 17M59 18L60 19L59 18M77 18L78 19L77 18M86 18L87 19L86 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M88 18L91 21L88 18M163 18L163 21L164 21L163 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3974a5",
      stroke: "none"
    },
    d: "M88 19L89 20L88 19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M164 19L165 20L164 19M59.3333 20.6667L59.6667 21.3333L59.3333 20.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M78 20L78 23L79 23L78 20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3974a5",
      stroke: "none"
    },
    d: "M89 20L90 21L89 20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M58.3333 21.6667L58.6667 22.3333L58.3333 21.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M165 21L164 23L166 23L165 21M72 22L73 23L72 22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M88 22L89 23L88 22M90 22L91 23L90 22M166 22L167 23L166 22M72 24L73 25L72 24M91.3333 24.6667L91.6667 25.3333L91.3333 24.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M92 26L92 29L93 29L92 26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M167 26L167 83L168 83L168 44L167 26M72 29L73 30L72 29M91 29L92 30L91 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M91 31L92 32L91 31M166 32L166 85L167 85L167 49L166 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M74 33L75 34L74 33M89 33L90 34L89 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M91 33L92 34L91 33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M75 34L76 35L75 34M82 34L83 35L82 34M88 34L89 35L88 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M89 35L90 36L89 35M77 36L78 37L77 36M87 36L88 37L87 36M75 37L76 38L75 37M79 37L80 38L79 37M84 37L85 38L84 37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M58 40L58 48L59 48L58 40M58 49L62 51L62 50L58 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M112 49L113 50L112 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M65 50L65 51L72 51L65 50M73 50L74 51L73 50M75 50L76 51L75 50M77 50L78 51L77 50M79 50L80 51L79 50M81 50L81 51L111 51L81 50z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M114 52L115 53L114 52M117 54L118 55L117 54M114 56L115 57L114 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M193 56L193 57C206.71 61.3447 217.199 67.9213 221 83L222 83C219.559 66.7177 207.543 59.5041 193 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M116.667 57.3333L117.333 57.6667L116.667 57.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M174 90L175 90L175 58L192 58C168.869 48.294 174 75.9715 174 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fed444",
      stroke: "none"
    },
    d: "M175 58C176.28 76.789 178.445 103.315 158 113.235C151.374 116.451 144.143 116 137 116C110.112 116 61.7648 106.829 59.0895 145C58.1176 158.867 59 173.098 59 187C59 195.235 58.6782 203.509 64.5571 210.079C80.8476 228.287 117.314 226.272 139 222.246C147.952 220.584 157.851 217.424 163.697 209.995C170.339 201.555 167 184.181 167 174L112 174L112 166L177 166C188.599 166 200.622 167.117 209.999 158.867C232.035 139.48 232.779 81.5615 208.91 62.9282C199.26 55.3945 186.383 58 175 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M31 58L32 59L31 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M29.6667 59.3333L30.3333 59.6667L29.6667 59.3333M113 59L114 60L113 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M23 60L24 61L23 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M26.6667 60.3333L27.3333 60.6667L26.6667 60.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M21 61L22 62L21 61M19 62L20 63L19 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M114.333 62.6667L114.667 63.3333L114.333 62.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M18 63L19 64L18 63M15 65L16 66L15 65M14 66L15 67L14 66M13 67L14 68L13 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M13 68L14 69L13 68M12 69L13 70L12 69M11 70L12 71L11 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M8 73L9 74L8 73M7 75L8 76L7 75M6 77L7 78L6 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M7 77L8 78L7 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M5 79L6 80L5 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M6 79L7 80L6 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M4 82L5 83L4 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M160 82L161 83L160 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M222.333 84.6667L222.667 85.3333L222.333 84.6667M3 85L4 86L3 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M165 86L164 92L165 92L165 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M223 86L223 90L224 90L223 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M3 87L4 88L3 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M2 88L3 89L2 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M163 88L164 89L163 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M166 88L167 89L166 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M161 89C159.861 94.0948 158.719 97.4276 153 98L152 102L155 102L162 97L161 89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3974a5",
      stroke: "none"
    },
    d: "M165 90L166 91L165 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M2.33333 91.6667L2.66667 92.3333L2.33333 91.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3974a5",
      stroke: "none"
    },
    d: "M161 91L162 92L161 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M165 91L166 92L165 91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M163.333 92.6667L163.667 93.3333L163.333 92.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M1 93L2 94L1 93M164 93L165 94L164 93M173 93L173 96L174 96L173 93M224.333 93.6667L224.667 94.3333L224.333 93.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M162 95L163 96L162 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M163 95L164 96L163 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M152 96L153 97L152 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M172.333 96.6667L172.667 97.3333L172.333 96.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M160 97L155 103L160 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M161 98L162 99L161 98M171.333 98.6667L171.667 99.3333L171.333 98.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3974a5",
      stroke: "none"
    },
    d: "M153 99L155 101L153 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M160 99L161 100L160 99M0.333333 100.667L0.666667 101.333L0.333333 100.667M159 100L160 101L159 100M170.333 100.667L170.667 101.333L170.333 100.667M158 101L159 102L158 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M153 102L152 105L155 103L153 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M169.333 102.667L169.667 103.333L169.333 102.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3974a5",
      stroke: "none"
    },
    d: "M153 104L154 105L153 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M154 104L155 105L154 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M145 106L145 107L151 106L145 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M167 105L168 106L167 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M136 106L137 107L136 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3974a5",
      stroke: "none"
    },
    d: "M148.667 106.333L149.333 106.667L148.667 106.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M150 106L151 107L150 106M166 106L167 107L166 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M139 107L139 108L145 108L139 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M146.667 107.333L147.333 107.667L146.667 107.333M165 107L166 108L165 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M71 108L69 109L69 110L71 108M76 108L76 109L80 109L76 108M136 108L136 109L139 109L136 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M141.667 108.333L142.333 108.667L141.667 108.333M164 108L165 109L164 108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M72.6667 109.333L73.3333 109.667L72.6667 109.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M76 109L77 110L76 109M163 109L164 110L163 109M71 110L72 111L71 110M161 110L161 112L163 110L161 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M66 111L67 112L66 111M63.6667 112.333L64.3333 112.667L63.6667 112.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M66 112L67 113L66 112M155 113L155 114L160 113L155 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M62.3333 113.667L62.6667 114.333L62.3333 113.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M65 113L66 114L65 113M63 114L64 115L63 114M145 115L145 116L155 115L145 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M57 116L57 119L58 119L57 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M80 116L80 117L88 117L80 116M73 119L73 120L80 118L73 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M56 120L57 121L56 120z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M57 120L58 121L57 120M69 121L69 122L73 121L69 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M53.3333 121.667L53.6667 122.333L53.3333 121.667M55 121L56 122L55 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M0 122L0 125L1 125L0 122M68 122L69 123L68 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M54 123L55 124L54 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M55 123L56 124L55 123M67 123L68 124L67 123M66 124L67 125L66 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M53 125L54 126L53 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M54 125L55 126L54 125M65 125L66 126L65 125M64 126L65 127L64 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M52 128L53 129L52 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M62 128C56.7004 143.696 58 159.59 58 176C58 184.826 56.9468 194.376 59 203L60 203C57.0708 179.822 55.533 149.949 64 128L62 128M224 129L224 132L225 132L224 129M1.33333 131.667L1.66667 132.333L1.33333 131.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M2.33333 131.667L2.66667 132.333L2.33333 131.667M51.3333 131.667L51.6667 132.333L51.3333 131.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M52 131L53 132L52 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfdfc",
      stroke: "none"
    },
    d: "M224 132C223.357 136.773 222.173 141.666 220.008 146C205.921 174.193 175.619 165.701 150 166.004C140.049 166.122 113.148 161.466 113 174L168 174C168 183.76 170.264 196.835 166.518 205.996C160.581 220.515 138.714 223.998 125 224L125 225L225 225L225 161L224 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M223.333 134.667L223.667 135.333L223.333 134.667M51 135L51 138L52 138L51 135M2.33333 136.667L2.66667 137.333L2.33333 136.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M4 136L5 137L4 136M50 136L50 161L51 161L50 136M3 137L4 138L3 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M222.333 138.667L222.667 139.333L222.333 138.667M3 140L4 141L3 140z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M4.33333 140.667L4.66667 141.333L4.33333 140.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M221.333 141.667L221.667 142.333L221.333 141.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M5 144L6 145L5 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M220.333 144.667L220.667 145.333L220.333 144.667M5 146L6 147L5 146M219.333 146.667L219.667 147.333L219.333 146.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M7.33333 148.667L7.66667 149.333L7.33333 148.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M218 148L219 149L218 148M217.333 149.667L217.667 150.333L217.333 149.667M8 152L9 153L8 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M9 152L10 153L9 152M12 152L13 153L12 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M215 153L216 154L215 153M9 154L10 155L9 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M10 154L11 155L10 154M14 154L15 155L14 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M214 154L215 155L214 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M11 155L12 156L11 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M213 155L210 159L213 155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M13.3333 157.667L13.6667 158.333L13.3333 157.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M12 158L13 159L12 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M14 159L16 161L14 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M209 159L210 160L209 159M14 160L15 161L14 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M24 160L25 161L24 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M15 161L16 162L15 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M18 161L21 164L21 163L18 161M22 161L23 162L22 161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M207 161L208 162L207 161M204.667 162.333L205.333 162.667L204.667 162.333M18 163L19 164L18 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M50 163L50 167L51 167L50 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M202.667 163.333L203.333 163.667L202.667 163.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M21.6667 164.333L22.3333 164.667L21.6667 164.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M200.667 164.333L201.333 164.667L200.667 164.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M23 165L24 166L23 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M196 165L196 166L200 166L196 165M24 166L25 167L24 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#385b77",
      stroke: "none"
    },
    d: "M26 166L26 167L29 167L26 166M31 166L32 167L31 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M112 166L112 174L113 174L115 167L112 166M116 166L117 167L116 166M120.667 166.333L121.333 166.667L120.667 166.333M128 166L128 167L144 167L128 166M160 166L160 167L192 167L160 166M27.6667 167.333L28.3333 167.667L27.6667 167.333M167 174L167 204L168 204L167 174M142 187L142 188L146 188L142 187M137 191L141 189L137 191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fcfdfc",
      stroke: "none"
    },
    d: "M140.849 188.784C129.307 192.846 136.059 210.51 146.985 206.137C157.758 201.826 151.797 184.931 140.849 188.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f9e7a0",
      stroke: "none"
    },
    d: "M147 188L150 190L147 188M150 190L151 191L150 190M151 191L152 192L151 191M135.333 192.667L135.667 193.333L135.333 192.667M152.333 192.667L152.667 193.333L152.333 192.667M134.333 194.667L134.667 195.333L134.333 194.667M153 194L153 201L154 201L153 194M134.333 200.667L134.667 201.333L134.333 200.667M152.333 201.667L152.667 202.333L152.333 201.667M135 202L136 203L135 202M60 203L61 208L62 208L60 203M136 203L136 205L138 205L136 203M151 203L152 204L151 203M150 204L151 205L150 204M166 204L166 207L167 207L166 204M138 205L141 207L138 205M147 207L150 205L147 207M142 207L142 208L146 208L142 207M62 208L64 210L64 208L62 208M165 208L166 209L165 208M164 209L162 212L164 209M64 210L65 211L64 210M65 211L66 212L65 211M66 212L67 213L66 212M161 212L160 214L162 214L161 212M67.6667 213.333L68.3333 213.667L67.6667 213.333M69 214L70 215L69 214M159 214L160 215L159 214M70 215L71 216L70 215M158 215L159 216L158 215M72 216L75 218L72 216M154 218L157 216L154 218M75.6667 218.333L76.3333 218.667L75.6667 218.333M152.667 218.333L153.333 218.667L152.667 218.333M77 219L77 220L80 220L77 219M149.667 219.333L150.333 219.667L149.667 219.333M80 220L80 221L86 222L80 220M145.667 220.333L146.333 220.667L145.667 220.333M143 221L144 222L143 221M88 222L88 223L91 223L88 222M137 222L137 223L141 223L137 222M93 223L93 224L96 224L93 223M132 223L132 224L136 224L132 223M103 224L103 225L125 225L103 224z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.297bf1b2a50d6d8d7b89cb2f62128915.svg";
export { ForwardRef as ReactComponent };